import { Pipe } from '@angular/core';
var EveryPipe = (function () {
    function EveryPipe() {
    }
    EveryPipe.prototype.transform = function (input, predicate) {
        return Array.isArray(input) ? input.every(predicate) : false;
    };
    return EveryPipe;
}());
export { EveryPipe };
EveryPipe.decorators = [
    { type: Pipe, args: [{ name: 'every' },] },
];
/** @nocollapse */
EveryPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=every.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/every.js
// module id = 199
// module chunks = 4